<template>
  <BNavbar variant="dark" type="dark" class="bg-primary shadow-sm header-bar">
    <BContainer fluid class="d-flex align-items-center justify-content-between">
      <BNavbarBrand to="/" class="text-white d-flex align-items-center">
        <img src="@/assets/logo.png" alt="Logo" class="me-2" style="height: 32px;" />
        嘎嘎狗玩股票
      </BNavbarBrand>
      <!-- 目前查看的股票名稱+代碼 -->
      <div v-if="stockStore.currentCode" class="stock-title text-white">
        <span class="stock-header-name">{{ stockStore.currentName }}</span>
        <span class="stock-header-code">{{ stockStore.currentCode }}</span>
      </div>
    </BContainer>
  </BNavbar>
</template>

<script setup>
import {
  BNavbar,
  BNavbarBrand,
  BContainer
} from 'bootstrap-vue-next'
import { useStockStore } from '@/stores/stockStore'

const stockStore = useStockStore()
</script>

<style scoped>
.header-bar {
  height: 48px;
  flex-shrink: 0;
}

.stock-title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.2;
}

.stock-header-name {
  font-size: 13px;
  font-weight: 600;
}

.stock-header-code {
  font-size: 11px;
  opacity: 0.8;
}
</style>
